import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient'
import { routeTree } from './routeTree.gen'
import { I18nProvider } from './i18n/I18nProvider'
import { NotFoundPage } from './pages/NotFoundPage'

// Unknown routes -> 404, regardless of auth state (MEC-3250). Wired here via
// the router's `defaultNotFoundComponent`, not on __root.tsx's own
// `notFoundComponent` — __root.tsx is explicitly public/unowned by this
// story (MEC-3250: "inchangé ... pas touché par cette story") and stays
// untouched; the router instance is the least invasive place to apply a
// default that must hold across every route, authenticated or not.
const router = createRouter({ routeTree, defaultNotFoundComponent: NotFoundPage })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const root = document.getElementById('root')
if (!root) throw new Error('#root element not found')

// Pick locale by navigator.language, fallback to fr-CA
const locale = navigator.language.toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA'

createRoot(root).render(
  <StrictMode>
    <I18nProvider locale={locale}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
)
